<template>
  <v-dialog v-model="dialogModel" width="600" @click:outside="handleCloseDivInputs" @keydown.esc="handleCloseDivInputs">
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-title class="px-4 py-2 d-flex justify-space-between grey darken-3">
          <span class="text-subtitle-1 font-weight-medium white--text">{{ typeLine ? 'Editar' : 'Novo' }}</span>

          <v-spacer />
          <v-icon color="white" :size="20" @click="handleCloseDivInputs">close</v-icon>
        </v-card-title>

        <v-divider />

        <v-container class="pa-0">
          <v-row no-gutters class="d-flex align-center px-3 pt-8 pb-4">
            <v-col cols="4">
              <v-text-field
                dense
                hide-details
                v-model="attributeModel"
                class="mr-2 input-attr"
                color="grey darken-3"
                :disabled="!editableKey"
                label="Atribute"
                required
                :rules="labelRules"
              />
            </v-col>

            <v-col cols="3" class="px-3" v-if="!this.isSwitch && !showHeadersType">
              <v-select
                :items="listTypesValues"
                v-model="radioGroupType"
                label="Type"
                class
                hide-details
                dense
                color="grey darken-3"
                @change="handleSetValueType"
                required
                :rules="typeRules"
              />
            </v-col>

            <v-col cols="5" v-if="!this.isSwitch && !showHeadersType">
              <v-text-field
                dense
                hide-details
                v-model="valueModel"
                label="Value"
                color="grey darken-3"
                :disabled="isObject"
              />
            </v-col>

            <v-col cols="5" v-if="this.isSwitch && !showHeadersType">
              <v-switch v-model="valueModel" label="Value" dense class="mt-0" color="grey darken-3" hide-details />
            </v-col>

            <v-col cols="5" v-if="showHeadersType">
              <v-select
                :items="listTypes"
                v-model="valueModel"
                label="Value"
                class
                hide-details
                dense
                append-icon="zmdi zmdi-chevron-down"
                color="grey darken-3"
                required
                :rules="typeHeadersRules"
              />
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer />

          <v-btn class="grey darken-3 white--text" @click="HandleAddAttribute">
            <SaveIcon size="16" class="mr-2" />Salvar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { SaveIcon } from 'vue-feather-icons';

export default {
  components: {
    SaveIcon
  },

  data: () => ({
    attributeModel: '',
    valueModel: '',
    radioGroupType: '',
    showMenu: false,
    x: null,
    y: null,
    isSwitch: false,
    isObject: false,
    listTypes: ['date', 'dateTime', 'decimal', 'zipcode', 'phone', 'cpf', 'cnpj', 'percentageSymbol'],
    listTypesValues: ['string', 'number', 'boolean', 'object'],
    showHeadersType: false,
    dialogModel: true,
    valid: true,
    labelRules: [v => !!v],
    typeRules: [v => !!v],
    typeHeadersRules: [v => !!v]
  }),

  props: {
    editableKey: { type: Boolean, default: true },
    typeLine: { type: Boolean, default: false, required: true },
    objItem: { type: Object, default: { key: '', value: '' }, required: true },
    headersType: { type: Boolean, default: false }
  },

  mounted() {
    if (this.typeLine) {
      this.attributeModel = this.objItem.key;
      this.valueModel = this.objItem.value;
      this.isSwitch = false;
      let typeOf = typeof this.objItem.value;

      if (this.objItem.value.toString() == 'false' || this.objItem.value.toString() == 'true') {
        this.isSwitch = true;
        this.valueModel = this.objItem.value.toString() == 'false' ? false : true;
      }

      if (this.listTypesValues.indexOf(typeOf) >= 0) {
        this.radioGroupType = typeOf;
      }
    }
  },

  methods: {
    handleCloseDivInputs() {
      this.$emit('close');
    },

    HandleAddAttribute() {
      if (!this.$refs.form.validate(true)) return;

      let actionType = this.typeLine ? 'edit' : 'add';

      if (this.valueModel == 'false' || this.valueModel == 'true') {
        this.valueModel = this.valueModel == 'false' ? false : true;
      }

      this.$emit('actionList', { type: actionType, key: this.attributeModel, value: this.valueModel });
    },

    handleSetValueType() {
      this.isObject = false;

      if (this.radioGroupType === 'string') {
        this.valueModel = this.valueModel.toString();
      }

      if (this.radioGroupType === 'number') {
        this.valueModel = parseFloat(this.valueModel) ? parseFloat(this.valueModel) : this.valueModel;
      }

      if (this.radioGroupType === 'boolean') {
        if (this.valueModel.toString() == 'false') {
          this.valueModel = false;
        }

        if (this.valueModel.toString() == 'true') {
          this.valueModel = true;
        }
      }

      if (this.radioGroupType === 'object') {
        let objectDefault = '{"": ""}';

        this.isObject = true;
        this.valueModel = JSON.parse(objectDefault);
      }
    }
  },

  watch: {
    attributeModel: {
      deep: true,
      handler: function(newValue, oldValue) {
        if (newValue) {
          if (this.headersType && newValue == 'type') {
            this.showHeadersType = true;
          } else {
            this.showHeadersType = false;
          }
        }
      }
    }
  }
};
</script>
